<script type='ts' setup>
import { useAclStore } from '../store/acl'
import Footer from '~/components/layouts/footer.vue'
import Nav from '~/components/layouts/nav.vue'
import { useAlertStore } from '~/store/alert'

const $acl = useAclStore()
const $alert = useAlertStore()
const $nav = useNavStore()

onMounted(() => {
  $acl.checkSession()
})
useHead({
  title: computed(() => $nav.title ? `${$nav.title} - Cel-Elements` : 'Cel-Elements'),
})
</script>
<template>
  <a-layout theme="light">
    <Nav />
    <a-alert v-if="$alert?.error" :message="$alert.error" type="error" />
    <slot />

    <Footer />
  </a-layout>
</template>

<style scoped>

</style>
